module.exports = "// app.js\n\nrequire('great-component/dist/great-component.css')\n\nimport Vue from 'vue'\nimport GreatComponent from 'great-component'\n\nVue.use(GreatComponent)\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src-docs/app/snippets/installation-commonjs.js
 ** module id = 240
 ** module chunks = 2
 **/